// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__dNJXJ","UdTIS":"Spinner_UdTIS__NzJob"};